import React from 'react';

export const SellerStories: React.FC = () => {
  const stories = [
    {
      name: 'Robert M.',
      property: '24-Unit Building, Phoenix',
      situation: 'Inherited Property with Deferred Maintenance',
      story: 'I inherited a 24-unit apartment building from my father, but I live across the country and had no interest in being a landlord. The property needed significant repairs that I could not afford to make. Several agents told me I would need to invest at least $150,000 in repairs before I could list it. I contacted this team, and they made me a fair offer within a week. They purchased the property as-is, and I closed in 35 days without spending a dollar on repairs. The process was straightforward and professional.',
      outcome: 'Closed in 35 days, no repairs needed'
    },
    {
      name: 'Linda S.',
      property: '16-Unit Building, Denver',
      situation: 'Retirement and Relocation',
      story: 'After managing my apartment building for 22 years, I was ready to retire and move closer to my grandchildren. I wanted to sell quickly so I could relocate before the school year started. Traditional sales in my market were taking 6-9 months, which would not work for my timeline. I reached out to this company, and they understood my situation. They moved quickly through their evaluation and made me a competitive offer. We closed in 28 days, and I was able to move in time for the new school year.',
      outcome: 'Closed in 28 days, met retirement timeline'
    },
    {
      name: 'James and Patricia K.',
      property: '32-Unit Building, Austin',
      situation: 'Partnership Dissolution',
      story: 'My business partner and I needed to dissolve our partnership and sell our apartment building quickly. We were concerned about the time and complexity of a traditional sale while dealing with our partnership issues. This team provided a solution that worked for both of us. They handled all the details professionally, worked with both our attorneys, and closed on a timeline that met our needs. The transaction was smooth despite the complexity of our situation.',
      outcome: 'Closed in 42 days, partnership resolved'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real Stories from Real Sellers
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Every apartment building sale has a unique story. Here are experiences from sellers who chose to work with us instead of pursuing traditional sales.
          </p>
        </div>

        <div className="space-y-12">
          {stories.map((story, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-sm">
              <div className="flex items-start gap-6 mb-6">
                <div className="flex-shrink-0 w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{story.name}</h3>
                  <div className="text-teal-600 font-semibold mb-1">{story.property}</div>
                  <div className="text-gray-500 text-sm">{story.situation}</div>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed mb-6 pl-22">
                {story.story}
              </p>
              <div className="pl-22 flex items-center gap-3">
                <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-teal-700 font-semibold">{story.outcome}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">
              Your Story Matters to Us
            </h3>
            <p className="text-lg leading-relaxed opacity-95 mb-8">
              Every seller has unique circumstances, goals, and concerns. We take the time to understand your specific situation and tailor our approach accordingly. Whether you are dealing with financial pressure, family transitions, partnership issues, or simply want to move on from property ownership, we are here to help.
            </p>
            <p className="text-lg leading-relaxed opacity-95">
              We invite you to share your story with us. There is no obligation, no pressure, and no cost for our evaluation. Let us show you how we can provide a solution that works for your unique situation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
